import { useParameterStore } from "@/frontend/store/ParameterStore";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { I18n } from "@/i18n/I18n";
import { ParameterType, ParameterSubjectType, ParameterInputType, ParameterReply } from "@/types/parameterTypes";
import { Form } from "react-bootstrap";
import { useShallow } from "zustand/react/shallow";
import { GenericParameterSelect } from "./GenericParameterSelect";
import { ParameterAddButton } from "./ParameterAddButton";
import { useGetParamsForRepeatingStepCycle } from "@/frontend/hooks/parameters";
import { ROOT_TYPES } from "@/types/containerTypes";

export function ParameterForRepeatingStepCycleSelector(props: {
  onUpdate: (id: string) => void,
  currentId: string,
 }) {
  const { onUpdate, currentId } = props;
  const parameters = useGetParamsForRepeatingStepCycle();
  const currentParameter = useParameterStore(useShallow(state => state.parameters.find(p => p.id === currentId)));
  const rootId = useTreeStore(state => state.rootId);
  // A new list to cycle through is a procedure parameter, which only a procedure can have:
  // in a block or implementation function, steps cycle through step outputs only.
  const rootIsProcedure = useTreeStore(state => state.rootType === ROOT_TYPES.PROCEDURE);

  return (
    <div className='flex-fill'>
      <Form.Label className="col-form-label col-form-label-sm">{I18n.get('valuesToCycleThrough')}:</Form.Label>
      <GenericParameterSelect
        parameters={parameters}
        currentParameter={currentParameter}
        createReference={(param) => onUpdate(param.id)}
        deleteReference={() => onUpdate('')}
        blockSelectNone
      >
      { rootIsProcedure && <div className='dropdown-item'>
        <ParameterAddButton
          subjectId={rootId}
          parameterType={ParameterType.CONFIG}
          subjectType={ParameterSubjectType.PROCEDURE}
          defaultInputType={ParameterInputType.LIST}
          onCreate={(response: ParameterReply) => {
            if (response.parameter) {
              onUpdate(response.parameter.id);
            }
          }}
        />
      </div> }
      </GenericParameterSelect>
    </div>
  );
}
